import React, {Component} from "react";
import {Control, Field, Input} from "bloomer";
import SectionName from "../../../../elements/SectionName";
import InputWarning from "../../../../elements/InputWarning";
import {INVALID_FIELD_STYLE} from "../../../../utils/Constants";
import Spacer from "../../../../elements/Spacer";
import ITemplateState from "../ITemplateState";
import FieldDescription from "../../../../elements/FieldDescription";
import WordsLabel from "../../../../elements/WordsLabel";


class MovieToEmoji extends Component<{}, ITemplateState> {
    public INPUT_CHARACTERS_LIMIT: number = 1000;

    public constructor(props: {}) {
        super(props);

        this.state = {
            textInput: "",
            textInputEmpty: false,
            showLimitWarning: false,
            charactersCount: 0
        };
    }

    public handleTextInputChange = (e: any) => {
        const value = e.target.value;
        const charactersCount = value.trim().length;
        this.setState({
            textInput: value,
            textInputEmpty: false,
            charactersCount,
            showLimitWarning: charactersCount > this.INPUT_CHARACTERS_LIMIT
        });
    };

    public resetForm = () => {
        this.setState({
            textInput: "",
            textInputEmpty: false,
            showLimitWarning: false,
            charactersCount: 0
        });
    };

    public validateForm = () => {
        if (!this.state.textInput.trim() || this.state.showLimitWarning) {
            if (!this.state.textInput.trim()) {
                this.setState({
                    textInputEmpty: true
                });
            }
            return false;
        }

        return true;
    };

    public getFormData = () => {
        return {
            text: this.state.textInput.trim()
        };
    };

    public render() {
        return <React.Fragment>
            <div>Converts movie title into emoji.</div>
            <Spacer/>
            <Field>
                <Control>
                    <SectionName>Movie Name:</SectionName>
                    <FieldDescription>Sample: Spider-Man</FieldDescription>
                    <Input
                        style={(this.state.textInputEmpty || this.state.showLimitWarning) ? INVALID_FIELD_STYLE : undefined}
                        onChange={this.handleTextInputChange}
                        onPaste={this.handleTextInputChange}
                        value={this.state.textInput}
                        placeholder={"Enter movie name"}
                    />
                    <div>
                        {
                            this.state.textInputEmpty ? <InputWarning>Please input a movie name.</InputWarning> : <></>
                        }
                        {
                            this.state.showLimitWarning ?
                                <InputWarning>Input size limit has been exceeded. Please decrease the
                                    size.</InputWarning>
                                : <></>
                        }
                        <WordsLabel>{this.state.charactersCount}</WordsLabel>
                    </div>
                </Control>
            </Field>
            <Spacer/>
        </React.Fragment>;
    }
}

export default MovieToEmoji;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/TextCompletion/templates/MovieToEmoji.tsx